import React, { FunctionComponent, useCallback, useMemo, useState } from 'react';
import WideContent from 'core/layout/content/wide-content';
import Translate from 'ui/atoms/translate';
import Section from 'ui/atoms/section';
import EmailHistoryTableView from './email-history-table-view';
import { AdminApi } from 'api';
import useApiCall from 'hooks/use-api-call';
export interface EmailHistoryProps {
  investorId: string;
  hasPermission: boolean;
}

const EmailHistoryView: FunctionComponent<EmailHistoryProps> = ({ investorId, hasPermission }) => {
  const { withApi, makeAuthenticatedApi } = useApiCall();

  const adminApi: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const [emailsResent, setEmailResent] = useState<string[]>([]);

  const resendEmail = useCallback(
    (emailId: string) => {
      withApi(async () => {
        await adminApi.adminMailsResendCreate({
          id: emailId,
        });
      });
      setEmailResent([...emailsResent, emailId]);
    },
    [withApi, adminApi, emailsResent],
  );

  const isEmailResent = useCallback(
    (emailId: string) => {
      return emailsResent.filter((email) => email === emailId).length > 0;
    },
    [emailsResent],
  );

  return (
    <Section>
      <WideContent
        title={<Translate name="dashboardIssuerInvestorDetails.emails" />}
        ignorePageTitle
        titleSpacing="medium"
      >
        <EmailHistoryTableView
          investorId={investorId}
          hasPermission={hasPermission}
          resendEmail={resendEmail}
          isEmailResent={isEmailResent}
          skipFilterUrlSync={true}
        />
      </WideContent>
    </Section>
  );
};

export default EmailHistoryView;
